// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicSystemConfigurationControllerGetEnvironmentVariablesData } from './PublicSystemConfigurationControllerGetEnvironmentVariablesData.gen';
import type { PublicSystemConfigurationControllerGetEnvironmentVariablesErrors } from './PublicSystemConfigurationControllerGetEnvironmentVariablesErrors.gen';
import type { PublicSystemConfigurationControllerGetEnvironmentVariablesResponses } from './PublicSystemConfigurationControllerGetEnvironmentVariablesResponses.gen';
import type { PublicSystemConfigurationControllerGetPublicSystemConfigurationData } from './PublicSystemConfigurationControllerGetPublicSystemConfigurationData.gen';
import type { PublicSystemConfigurationControllerGetPublicSystemConfigurationErrors } from './PublicSystemConfigurationControllerGetPublicSystemConfigurationErrors.gen';
import type { PublicSystemConfigurationControllerGetPublicSystemConfigurationResponses } from './PublicSystemConfigurationControllerGetPublicSystemConfigurationResponses.gen';
import type { PublicSystemConfigurationControllerGetSystemConfigurationData } from './PublicSystemConfigurationControllerGetSystemConfigurationData.gen';
import type { PublicSystemConfigurationControllerGetSystemConfigurationErrors } from './PublicSystemConfigurationControllerGetSystemConfigurationErrors.gen';
import type { PublicSystemConfigurationControllerGetSystemConfigurationResponses } from './PublicSystemConfigurationControllerGetSystemConfigurationResponses.gen';
import type { PublicSystemConfigurationControllerUpdateSystemConfigurationData } from './PublicSystemConfigurationControllerUpdateSystemConfigurationData.gen';
import type { PublicSystemConfigurationControllerUpdateSystemConfigurationErrors } from './PublicSystemConfigurationControllerUpdateSystemConfigurationErrors.gen';
import type { PublicSystemConfigurationControllerUpdateSystemConfigurationResponses } from './PublicSystemConfigurationControllerUpdateSystemConfigurationResponses.gen';

export class PublicSystemConfigurationController {
    /**
     * Get public system configuration
     */
    public static getPublicSystemConfiguration<ThrowOnError extends boolean = false>(options?: Options<PublicSystemConfigurationControllerGetPublicSystemConfigurationData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicSystemConfigurationControllerGetPublicSystemConfigurationResponses, PublicSystemConfigurationControllerGetPublicSystemConfigurationErrors, ThrowOnError>({ url: '/api/public/system-configurations/public', ...options });
    }
    
    /**
     * Get system configuration
     */
    public static getSystemConfiguration<ThrowOnError extends boolean = false>(options?: Options<PublicSystemConfigurationControllerGetSystemConfigurationData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicSystemConfigurationControllerGetSystemConfigurationResponses, PublicSystemConfigurationControllerGetSystemConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/system-configurations',
            ...options
        });
    }
    
    /**
     * Update system configuration
     */
    public static updateSystemConfiguration<ThrowOnError extends boolean = false>(options: Options<PublicSystemConfigurationControllerUpdateSystemConfigurationData, ThrowOnError>) {
        return (options.client ?? client).patch<PublicSystemConfigurationControllerUpdateSystemConfigurationResponses, PublicSystemConfigurationControllerUpdateSystemConfigurationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/system-configurations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * System environment variables
     */
    public static getEnvironmentVariables<ThrowOnError extends boolean = false>(options?: Options<PublicSystemConfigurationControllerGetEnvironmentVariablesData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicSystemConfigurationControllerGetEnvironmentVariablesResponses, PublicSystemConfigurationControllerGetEnvironmentVariablesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/system-configurations/env',
            ...options
        });
    }
}
